import React, {useState, useEffect} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Column from 'components/complex/transferList/Column';
import SearchHeader from 'components/complex/transferList/headers/SearchHeader';
import List from 'components/complex/transferList/List';
import FullNameItem from './listItems/FullNameItem';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import AddIcon from '@material-ui/icons/AddBoxOutlined'
import AddCandidate from 'components/popup/addCandidate/AddCandidate';
import getObjectValue from 'libs/getObjectValue';
import EmptyOptions from 'components/complex/transferList/options/EmptyOptions';

const style = theme => ({
    root: {},
    button: {
        marginTop: theme.spacing(1)
    }
});

function CandidateColumn({
                             classes,
                             items,
                             formikProps,
                             addedId,
                             markHistorical
                         }) {

    const [filteredItems, setFilteredItems] = useState([]);
    const [searchFilter, setSearchFilter] = useState('');
    const [addPopup, setAddPopup] = useState(false);

    const editable = getObjectValue('_editable', formikProps.values, true);
    const addedItems = getObjectValue(addedId, formikProps.values, []);

    useEffect(() => {

        let filter = items.filter(x => {
            const isAdded = addedItems.findIndex(z => z.id === x.id);
            if (isAdded >= 0) return false;

            let search = searchFilter.trim().toLowerCase();
            if (search.length <= 0) return true;

            let name = `${x.firstName} ${x.lastName}`;
            name = name.toLowerCase();
            return name.includes(search)
        });

        filter.sort((a, b) => a.firstName.localeCompare(b.firstName));

        setFilteredItems(filter)
        // eslint-disable-next-line
    }, [searchFilter, addedItems.length, items]);

    const handleSearchChange = (event) => {
        setSearchFilter(event.target.value);
    };

    return (
        <Column>
            <SearchHeader
                placeholder={Tr('search_placeholder_fullname')}
                title={Tr('candidates')}
                onChange={handleSearchChange}
                value={searchFilter}
            />
            <EmptyOptions/>
            <List
                grow
                ItemComponent={FullNameItem}
                items={filteredItems}
                itemProps={{
                    formikProps,
                    addedId,
                    markHistorical
                }}
            />
            <Button
                variant='text'
                onClick={() => setAddPopup(true)}
                Icon={AddIcon}
                className={classes.button}
                disabled={!editable}
            >
                {Tr('add_commission_candidate')}
            </Button>
            {addPopup && <AddCandidate
                onClose={() => setAddPopup(false)}
                formikProps={formikProps}
            />}
        </Column>
    )
}

CandidateColumn.propTypes = {
    classes: PropTypes.any,
    items: PropTypes.array,
};

CandidateColumn.defaultProps = {};

export default withStyles(style)(CandidateColumn);